var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "some-search-letters" },
    _vm._l(_vm.letter, function(item, idx) {
      return _c("li", { key: idx }, [
        _c("label", [
          _c("input", {
            attrs: { name: _vm.name, type: "radio" },
            domProps: { checked: item == _vm.initLetter, value: item },
            on: {
              click: function($event) {
                _vm.update(item)
              }
            }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(item))])
        ])
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63654fe6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63654fe6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/letterSearch/LetterBoss.vue
// module id = null
// module chunks = 